import { ArrowLeft, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState, type ReactNode } from 'react';
import { vars } from '../styles/theme.css';
import { text } from '../styles/text.css';
import { SettingsModal } from './SettingsModal';

const stickyStyle = {
  backgroundColor: vars.color.bgTranslucent,
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  borderBottom: `1px solid ${vars.color.border}`,
};

const gearStyle = {
  width: 32,
  height: 30,
  borderRadius: 8,
  color: vars.color.inkSoft,
  border: `1px solid ${vars.color.borderStrong}`,
  backgroundColor: vars.color.surface2,
};

/** Brand mark — clickable, always navigates to the home page. */
function Brand() {
  return (
    <Link to="/" className="flex items-center gap-2 -ml-1 px-1">
      <div
        className={`flex items-center justify-center text-white font-bold ${text.tag}`}
        style={{
          width: 22,
          height: 22,
          borderRadius: 6,
          backgroundColor: vars.color.accent,
          letterSpacing: '-0.02em',
          textTransform: 'none',
        }}
      >
        言
      </div>
      <span className={text.h3} style={{ color: vars.color.ink }}>
        Kotoba
      </span>
    </Link>
  );
}

/** Settings gear button + modal — used by both HomeHeader and SubHeader. */
function SettingsGear() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex items-center justify-center transition-colors"
        style={gearStyle}
        aria-label="Open settings"
      >
        <Settings size={15} strokeWidth={2} />
      </button>
      <SettingsModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}

/** Top-level home header with the app brand and settings. */
export function HomeHeader() {
  return (
    <header className="sticky top-0 z-30" style={stickyStyle}>
      <div className="max-w-reading mx-auto px-4 h-12 flex items-center justify-between">
        <Brand />
        <SettingsGear />
      </div>
    </header>
  );
}

/** Sub-page header — back arrow + label on the left, controls on the right. */
export function SubHeader({
  backTo,
  backLabel,
  right,
}: {
  backTo: string;
  backLabel: string;
  right?: ReactNode;
}) {
  return (
    <header className="sticky top-0 z-30" style={stickyStyle}>
      <div className="max-w-reading mx-auto px-3 h-12 flex items-center justify-between gap-2">
        <Link
          to={backTo}
          className="flex items-center gap-1 px-2 py-1.5 -ml-1 rounded-md transition-colors"
          style={{ color: vars.color.ink }}
        >
          <ArrowLeft size={18} strokeWidth={2} />
          <span
            className={text.body}
            style={{ fontWeight: 600, letterSpacing: '-0.01em' }}
          >
            {backLabel}
          </span>
        </Link>
        <div className="flex items-center gap-1.5">
          {right}
          <SettingsGear />
        </div>
      </div>
    </header>
  );
}
